import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Exchange} from './exchange';
import {Supplier} from "../../setting/suppliers/supplier";

@Injectable()
export class ExchangeService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('exchange?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('exchange/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('exchange/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('exchange/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('exchange/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(exchange: Exchange) {
        return this.http.post('exchange', exchange).map((response: Response) => response.json());
    }

    update(exchange: Exchange) {
        return this.http.put('exchange/' + exchange.id, exchange).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('exchange/' + _id).map((response: Response) => response.json());
    }
    getitemstock(branch,id) {
        return this.http.get('items/'+ branch + '/'+ id).map((response: Response) => response.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/views/pro/exchange/exchange.service.ts